<template>
  <div class="content" style="position: relative;" :style="{'background-image':'url('+require('@/assets/caoyuan.png')+')'}">
  <img src="@/assets/caoyuan.png" alt="" style="width: 100%;position: fixed;z-index: 1;opacity: 0.2;height: 100%; object-fit: cover;" />
    <div style="width: 1200px;margin: 0 auto;padding-top: 30px;
    position: relative;left: 50%;margin-left: -600px;z-index: 2;background: none;" v-loading="loading">
        <div class="title">
          {{detail.title}}
        </div>
        <div class="time">
            发布时间：{{timereturn(detail.time)}}
            <!-- <div style="margin-left: 30px;">
              浏览量：{{detail.look_num}}
            </div> -->
            <div style="margin-left: 30px;">
              来源：{{detail.source}}
            </div>
        </div>
        <div class="contents mavonEditor md" ref="editor" v-html="info">

        </div>
      </div>
  </div>

</template>

<script>
  import { InfoMation_detail } from "@/api/gw/zonghe.js"
  import { mavonEditor } from 'mavon-editor'
  import 'mavon-editor/dist/css/index.css'
  import E from 'wangeditor'
  export default {
    computed: {
  // 解析器配置
    prop () {
      let data = {
        subfield: false,// 单双栏模式
        defaultOpen: 'preview',//edit： 默认展示编辑区域 ， preview： 默认展示预览区域
        editable: false,    // 是否允许编辑
        toolbarsFlag: false,
        scrollStyle: true
      }
      return data
    }
  },
  components:{
        mavonEditor
      },
     data(){
      return{
        infomation_id:"",
        detail:"",
        loading:false,
        editor: null,
        info:""
      }
     },
     mounted(){
        if(this.$route.query.n){
            this.infomation_id = this.$route.query.n
            this.InfoMation_detail();
        }else{
          this.$message.error("该文章不存在");
          this.$router.push({
            path:"/"
          })
        }
     },
     beforeDestroy() {
         this.editor.destroy() // 组件销毁前，销毁编辑器
       },
     methods:{
      timereturn(dateTime){
				// 使用split方法以空格为分隔符分割字符串，得到一个数组
				  // 数组的第一个元素是日期部分，第二个元素是时间部分
				  const parts = dateTime.split(' ');
				  // 使用join方法将分割后的数组重新组合成字符串，但只包含日期部分
				  return parts[0];
			},
      InfoMation_detail(){
        this.loading = true
        InfoMation_detail({
          infomation_id:this.infomation_id
        }).then(res=>{
          this.detail = res.data
          this.info = res.data.content
          this.editor = new E(this.$refs.editor)
          this.editor.customConfig.onchange = (html) => {
            this.editorContent = html
          }
          this.editor.create()
        }).finally(()=>{
          this.loading = false
        })
      },
     }
  }
</script>

<style lang="scss" scoped>
  #app{
    background: #fff!important;
    background:-webkit-linear-gradient(top,white,lightblue,skyblue);
  }
.content{
  width: 100%;
  background-size: 100%;
  background: #fff!important;
  background:-webkit-linear-gradient(top,white,lightblue,skyblue);
}
.time{
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  color: #666;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.title{
  width: 100%;
  text-align: center;
  line-height: 40px;
  font-weight: bold;
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/wenDetail.vue